import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MessagingInbox } from '@gokrew/ui';

export const MessagesPage = () => {
  const [params, setParams] = useSearchParams();
  const composing = params.get('compose') === '1';
  const onComposingChange = useCallback(
    (open: boolean) => {
      setParams(
        (previous) => {
          const next = new URLSearchParams(previous);
          next.delete('conversation');
          if (open) next.set('compose', '1');
          else next.delete('compose');
          return next;
        },
        { replace: true }
      );
    },
    [setParams]
  );
  const onConversationChange = useCallback(
    (id: string | null) => {
      setParams(
        (previous) => {
          const next = new URLSearchParams(previous);
          next.delete('compose');
          if (id) next.set('conversation', id);
          else next.delete('conversation');
          return next;
        },
        { replace: true }
      );
    },
    [setParams]
  );
  return (
    <MessagingInbox
      conversationId={composing ? null : params.get('conversation')}
      onConversationChange={onConversationChange}
      isComposing={composing}
      onComposingChange={onComposingChange}
    />
  );
};
